import { facadeApi } from 'api'

export const approveHierarchyAccessRequestApi = (requestId: string) =>
  facadeApi.patch(`/hierarchy-requests/${requestId}/approve`)
